module.exports = __webpack_public_path__ + "static/media/Wheel.cbfc158f.png";